import Vue from 'vue'
import { isProd, isDef, isNull, Eval, Call } from './common'
import { utils } from '../utils'

export default function (options) {
  options = Object.assign({
    type: 'get',
    url: '',
    key: 'fetcher_default',

    $onError(...args) { utils.DefaultErrorHandler.call(this, ...args) },
    $onSuccess(body, key) { Vue.set(this, key, body) },
  }, options)

  const action_name = options.alias || (`fetcher_${options.key}`)
  return function () {
    const randstr = utils.RandomStr(5)
    const url = Eval(this, options.url)
    const payload = Eval(this, options.payload)
    const key = Eval(this, options.key)

    if (!isProd) console.info(`[${action_name}:${randstr}] loading "${url}" with `, payload)

    this.$http[options.type](url, payload)
      .then(r => {
        if (!isProd) console.info(`[${action_name}:${randstr}] got response with `, r)

        if (r.body && r.body.error)
          Call(this, options.$onError, r.body.error)
        else
          Call(this, options.$onSuccess, r.body, key)
      })
      .catch(err => {
        if (!isProd) console.info(`[${action_name}:${randstr}] get error `, err)

        Call(this, options.$onError, err)
      })
  }
}



// WEBPACK FOOTER //
// ./client/src/utils/fetcher.js